import styled from "styled-components";
import { DefaultParagraphSmallFactory, DefaultTitleMediumFactory } from "../../../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const ContentButtonsDocument = styled.div(() => ({
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    gap: "24px 32px",
    alignSelf: "stretch",
    flexWrap: "wrap",
}))

export const ContentButtonsNextAndBack = styled.div(({theme}) => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    alignContent: "center",
    gap: "24px 32px",
    alignSelf: "stretch",
    flexWrap: "wrap",
    [theme.breakpoint.lg()]: {
        marginTop: "60px",
    },
}))

export const ContentCheckListDocuments = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "20px",
    justifyContent: "center",
    alignSelf: "stretch",
    margin: "40px 0 40px 0",
}))

export const CheckListDocuments = styled.div(() => ({
    display: "flex",
    gap: "8px",
    alignSelf: "stretch",
}))

export const ContainerAttachmentAndSendDocuments = styled.div(({ theme }) => ({
    [theme.breakpoint.lg()]: {
        display: "grid",
        flexDirection: "column",
        gridTemplateColumns: "0.5fr 1.9fr",
        alignItems: "flex-start",
        gap: "32px",
    },
}))

export const ContentAttachmentAndSendDocuments = styled.div(() => ({
    gap: "32px",
    display: "flex",
    width: "100%",
}))

export const ContentTitle = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
}))

export const Title = styled.h2(({ theme }) => ({
    ...DefaultTitleMediumFactory({ theme }),
    marginBottom: "16px",
    [theme.breakpoint.lg()]: {
        marginBottom: "0",
    },
}))

export const Description = styled.p(({ theme }) => ({
    ...DefaultParagraphSmallFactory({ theme }),
}))

export const Divider = styled.div(({ theme }) => ({
    border: `1px solid ${theme.color.line.medium}`,
    width: '100%',
    margin: "40px 0 40px 0",
    [theme.breakpoint.lg()]: {
        margin: "60px 0 60px 0",
    },
}))

